import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Typography } from "@mui/material";
import CustomPagination from "../CustomPagination";
import { koKRGrid } from "../TableKRText";

function CustomToolbar(props: any) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <GridToolbarQuickFilter sx={{ marginLeft: "auto" }} />
    </GridToolbarContainer>
  );
}

const columns: GridColDef[] = [
  { field: "id", headerName: "id", width: 70 },
  { field: "name", headerName: "이름", width: 80 },
  { field: "email", headerName: "이메일", width: 200 },
  { field: "require_date", headerName: "요청일자", width: 230 },
  { field: "require_type", headerName: "요청내용", width: 80 },
  { field: "accepte_date", headerName: "허가일자", width: 200 },
  { field: "accepter", headerName: "허가자", width: 100 },
  { field: "reason", headerName: "사유", width: 300 },
  { field: "ins_date", headerName: "업로드 시간", width: 200 },
];

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface rowDetailType {
  id: number;
  name: string;
  email: string;
  require_date: string;
  require_type: string;
  accepte_date: string;
  accepter: string;
  reason: string;
  ins_date: string;
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const CalendarTable = (props: any) => {
  console.log("value", props.click_date);
  const [page, setPage] = useState(1);

  const [rows, setRows] = useState([]);

  // api 사용자 정보에서 페이지 정보를 담을 state
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  // 팝업 관리 state

  const getUploadFileList = async (ymd: any) => {
    var result = await axios.get("http://localhost:9680/attendanceHistory", {
      params: { page: page, ymd: ymd },
      withCredentials: true,
    });

    var datas = result.data.datas.map((data: any) => {
      return {
        id: data.idx,
        name: data.name,
        email: data.email,
        require_date: data.require_date,
        require_type: data.require_type,
        reason: data.reason,
        accepte_date: data.accepte_date,
        accepter: data.accepter,
        ins_date: data.ins_date,
      };
    });

    console.log("result.data", datas);

    setRows(datas);

    setPagination(result.data.pagination);
  };

  useEffect(() => {
    getUploadFileList(props.click_date);
  }, [page, props.click_date]);

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  return (
    <Box>
      <React.Fragment>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          휴가 목록
        </Typography>

        <ThemeProvider theme={theme}>
          <div style={{ height: "80vh", width: "100%" }}>
            <DataGrid
              editMode="row"
              rows={rows}
              columns={columns}
              checkboxSelection
              pageSize={100}
              components={{ Toolbar: CustomToolbar, Footer: CustomFooter }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              getRowId={(row) => row.id}
              localeText={koKRGrid}
              experimentalFeatures={{ newEditingApi: true }}
            />
          </div>
        </ThemeProvider>
      </React.Fragment>
    </Box>
  );
};

export default CalendarTable;
